import { Paper, Stack, Typography } from '@mui/material';
import { useGetUserLists } from '@/api/users/users';
import UserList from './UserList';

const UserHeader = () => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{ pb: 2 }}
  >
    <Stack spacing={0.25}>
      <Typography variant="h3">Users</Typography>
      <Typography variant="body2" color="text.secondary">
        Review organisation users and their access configuration.
      </Typography>
    </Stack>
  </Stack>
);

const UsersPage = () => {
  const { data, isLoading } = useGetUserLists();

  return (
    <Stack direction="column">
      <UserHeader />
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <UserList data={data} isLoading={isLoading} />
      </Paper>
    </Stack>
  );
};

export default UsersPage;
